import { useEffect, useMemo } from 'react'

import { User } from '@/models'
import { useHighlight } from '@/plugins/highlight'
import { usePostHog } from '@/plugins/posthog'
import { useIntercom } from '@/plugins/intercom'

interface UseIdentifyUserInMonitorsProps {
  user: User | null | undefined
  isLoading: boolean
}

export function useIdentifyUserInMonitors({
  user,
  isLoading,
}: UseIdentifyUserInMonitorsProps) {
  const highlight = useHighlight()

  const posthog = usePostHog()

  const intercom = useIntercom()

  const isUserAuthenticated = useMemo(
    () => !!user && !isLoading,
    [user, isLoading],
  )

  useEffect(() => {
    if (isUserAuthenticated) {
      const { id, email, firstName, lastName } = user!

      posthog?.identify(id, {
        email,
        name: `${firstName} ${lastName}`,
      })

      highlight?.identify(email, {
        id: id,
      })

      intercom?.identify(id, {
        email,
      })
    } else {
      highlight?.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthenticated, user])
}
